import React from 'react'
import styled from 'styled-components'
import MaintenanceImage from '../../assets/images/maintainance.svg';
import Delishop from '../../assets/icons/delishop_logo2.svg'

const MaintenanceContent = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    @media screen and (max-width: 612px) {
        width: 100%;
        padding: 10px;

        .img-maintenance{
            width: 100%;
        }
    }
`;

const TitleFeatures = styled.h3`
    color: #1b1b28;
    font-size: 1.75rem;
    font-weight: 600;
    text-align: center;
    padding-bottom: 0.50rem;
    font-family: Poppins, Helvetica, sans-serif;
    @media screen and (max-width: 612px) {
        font-size: 1.5rem !important;
    }

    @media screen and (max-width: 320px) {
        font-size: 1.2rem !important;
    }
`;

const ContentFeatures = styled.div`
    font-size: 1.25rem;
    font-weight: 300;
    @media screen and (max-width: 612px) {
        font-size: 1rem !important;
    }
`;

const ImageMaintenance = styled.div`
    margin-bottom: 30px;
`;

const ImageDelishopLogo = styled.div`
    width: 250px;
    margin-top: 70px;
    @media screen and (max-width: 320px) {
        margin-top: 30px !important;
    }
`;

const MaintenanceMode = () => {

  return (
    <div className='w-100 vh-100' style={{ backgroundColor: "azure"}}>
        <MaintenanceContent className='text-center'>
            <ImageMaintenance>
                <img src={MaintenanceImage} alt='Error Image Display' className='img-maintenance' width={600} />
            </ImageMaintenance>
            <TitleFeatures>
                Website is under Maintenance     
            </TitleFeatures>
            <ContentFeatures>
                We will be back soon!
            </ContentFeatures>
            <ImageDelishopLogo className='mx-auto'>
                <img src={Delishop} style={{maxWidth: 250}} alt='Error Image Display' />
            </ImageDelishopLogo>
        </MaintenanceContent>
    </div>
  )
}

export default MaintenanceMode